module.exports = __webpack_public_path__ + "img/portrait-061.03c5c1af.jpg";